import axiosInstance from "./axiosInstance";

export async function signIn(credentials) {
  try {
    const response = await axiosInstance.post("/login", {
      email: credentials.email,
      password: credentials.password,
    });

    if (response.status === 200) {
      sessionStorage.setItem("token_store", JSON.stringify(response.data));
      return response.data;
    }

    throw response;
  } catch (error) {
    throw error;
  }
}

export async function authenticateWithGoogle(credential) {
  try {
    const response = await axiosInstance.post("/social/google/authenticate", {
      credential,
    });

    if (response.status === 200) {
      if (response.data?.token) {
        sessionStorage.setItem(
          "token_store",
          JSON.stringify(response.data.token)
        );
      }
      return response.data;
    }

    throw response;
  } catch (error) {
    throw error;
  }
}

export async function resetPassword(credentials) {
  try {
    const response = await axiosInstance.post("/reset-password", {
      email: credentials.email,
    });

    if (response.status === 200) {
      return response.data;
    }

    throw response;
  } catch (error) {
    throw error;
  }
}

export async function authChangePassword(credentials) {
  try {
    const response = await axiosInstance.post("/change-password", {
      token: credentials.token,
      password: credentials.password,
      confirmPassword: credentials.confirmPassword,
    });

    if (response.status === 200) {
      return response.data;
    }

    throw response;
  } catch (error) {
    throw error;
  }
}
